export default __webpack_public_path__ + "static/media/class-8.3fa94999.jpg";